import React, {FC} from "react";
import {cartRemoveItem} from "../../../store/cart";
import {CartTrash} from "../../../svg";
import AsyncAction from "../../shared/AsyncAction";
import {useDispatch, useSelector} from "react-redux";
import {IState} from "../../../types/state";
import classNames from "classnames";
import cls from "../shop.module.scss";

interface IRemoveBtnProps {
    isAlternative: boolean;
    cartItemId: number;
    DeleteIntl: string
}

const RemoveButton:FC<IRemoveBtnProps> = (
    {
        isAlternative,
        cartItemId,
        DeleteIntl
    }
) => {
    const dispatch = useDispatch();
    const customer = useSelector((state: IState) => state.customer);
    const cartToken = useSelector((state: IState) => state.cartToken);
    const removeButtonsClassToggle = (loading: boolean) => {
        const loadingHandleObj = {'btn-loading': loading}
        if (!isAlternative) {
            return classNames(`btn text-light btn-orange btn-sm ${cls.remove_btn}`, loadingHandleObj)
        }
        return classNames(`btn-light btn-sm btn-svg-icon ${cls["del-icon-fms"]} ${cls["delete-btn-position"]}`, loadingHandleObj)
    }
    return (
        <AsyncAction
            action={() =>
                dispatch(cartRemoveItem(
                    cartItemId,
                    cartToken,
                    customer,
                ))
            }
            render={({run, loading}) => {
                if (!isAlternative) {
                    return (
                        <div onClick={run}>
                            <button className={removeButtonsClassToggle(loading)}>
                                {DeleteIntl}
                            </button>
                        </div>
                    )
                }
                return (
                    <button type="button" onClick={run} className={removeButtonsClassToggle(loading)}>
                        <CartTrash/>
                    </button>
                )
            }}
        />
    )
}

export default RemoveButton;
